import { CommonModule } from '@angular/common';

import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



import { MAT_DATE_LOCALE } from '@angular/material/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgxTippyModule } from 'ngx-tippy-wrapper';

import {

    FilterPipe,
    ChatMarkdownPipe,
    GlobalEnumPipe,
    HideTextPipe,
    OrderByPipe,
    TimeDurationsPipe
} from './pipe';

import { MaterialModule } from '@app/material.module';
import { TranslateModule } from '@ngx-translate/core';
import { NoRecordFoundComponent } from './components/no-record-found/no-record-found.component';
import { RtlsToolBarModule } from './components/rtls-tool-bar/rtls-tool-bar.module';

import { SignalRStateComponent } from './components/signalr-state/signalr-state.component';
import { TooltipComponent } from './components/tooltip/tooltip.component';

import { SpinnerOverlayComponent } from './components/spinner/component/spinner-overlay.component';

import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { TagItemPropertyTagDetailsComponent } from './components/tag-details/tag-item-property-tag-details.component';


import { UiSwitchModule } from 'ngx-ui-switch';
import { CrudActionButtonsComponent } from './components/crud-action-buttons/crud-action-buttons.component';
import { TagReportFiltersComponent } from './components/tags/report-filters/tag-report-filters/tag-report-filters.component';
import { RangeSwitchCaseDirective } from './directives/range-switch-case.directive';
import { VarDirective } from './directives/variable.directive';

import { RouterModule } from '@angular/router';

import { DetailPageHeaderComponent } from './components/detail-page-header/detail-page-header.component';
import { RtlsCountPieGraphicModule } from './components/rtls-count-pie-graphic/rtls-count-pie-graphic.module';

import { AutoFlightSwitchComponent } from '@app/modules/live/components/auto-flight-switch/auto-flight-switch.component';
import { ToggleSwitchComponent } from './components/toggle-switch/toggle-switch.component';

import { PostButtonExecutingModule } from './directives/post-button-executing/post-button-executing.module';
import { NgxSliderModule } from '@angular-slider/ngx-slider';

import { IconResolverComponent } from './components/icon-resolver/icon-resolver.component';
import { IconSelectorComponent } from './components/icon-selector/icon-selector.component';
import { FaIconListComponent } from './components/icon-selector/components/fa-icon-list/fa-icon-list.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { BaseComponent } from './components/base/base.component';
import { ListPageBaseComponent } from './components/list-page-base/list-page-base.component';
import { FuseScrollbarDirective } from '@fuse/directives/scrollbar';
import { DrawDetailContainerComponent } from './components/draw-detail-container/draw-detail-container.component';
import { ItemPropertyComponent } from './components/item-property/item-property.component';
import { ItemPropertyContainerComponent } from './components/item-property-container/item-property-container.component';
import { ProgressItemComponent } from './components/progress-item/progress-item.component';
import { MapItemComponent } from './components/map-item/map-item.component';
import { BakelorMapModule } from 'bakelor-map';

import { ToggleButtonComponent } from './components/toggle-button/toggle-button.component';
import { RecordBaseItemComponent } from './components/record-base-item/record-base-item.component';
import { TruncatePipesModule } from './pipe/truncate/truncate-pipes.module';
import { AutocompleteOffDirective } from './directives/autocomplete-off.directive';

import { LetDirective, PushPipe } from '@ngrx/component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { VirtualDropDownComponent } from './components/virtual-drop-down/virtual-drop-down.component';
import { NgSelectModule } from '@ng-select/ng-select';

import { ImageCropperModule } from 'ngx-image-cropper';
import { ImageEditorComponent } from './components/image-editor/image-editor.component';
import { ImageUploaderComponent } from './components/image-editor/components/image-uploader/image-uploader.component';
import { DropZoneDirective } from './directives/drop-zone.directive';
import { CoordinateEditorComponent } from './components/coordinate-editor/coordinate-editor.component';
import { DateRangeComponent } from './date-range/date-range.component';

import { NavizardLogoComponent } from './components/navizard-logo/navizard-logo.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { SecurityAlertComponent } from './toasts/security-alert/security-alert.component';
import { HttpDebugToastComponent } from './toasts/http-debug/http-debug-toast.component';
import { CopyableErrorToastComponent } from './toasts/copyable-error/copyable-error-toast.component';
import { UpdateModalComponent } from './components/update-modal/update-modal.component';
import { DebugContainerComponent } from './components/debug-container/debug-container.component';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { TagOnlineIndicatorComponent } from './components/tag-online-indicator/tag-online-indicator.component';
import { BarcodeEditComponent } from './components/barcode-edit/barcode-edit.component';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { RelativeTimePipe } from './pipe/relative-time.pipe';
import { CalendarTimePipe } from './pipe/calendar-time.pipe';
import { DatetimeFormatPipe } from './pipe/datetime-format.pipe';
import { DurationTimePipe } from './pipe/duration-time.pipe';
import { MapDesignerComponent } from './components/map-designer/map-designer.component';
import { MapDesignerDialogComponent } from './components/map-designer/components/map-designer-dialog/map-designer-dialog.component';
import { AnimatedTextComponent } from './components/animated-text/animated-text.component';
import { TextRevealComponent } from './components/text-reveal/text-reveal.component';
import { ScheduleSlotPresetEditorComponent } from './components/schedule-slot-preset-editor/schedule-slot-preset-editor.component';
import { DxDateBoxModule } from 'devextreme-angular/ui/date-box';
import { DxNumberBoxModule } from 'devextreme-angular/ui/number-box';
import { DxSelectBoxModule } from 'devextreme-angular/ui/select-box';
import { DxSwitchModule } from 'devextreme-angular/ui/switch';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import { DxChartModule } from 'devextreme-angular/ui/chart';
import { DxPieChartModule } from 'devextreme-angular/ui/pie-chart';
import { NorthernLightsComponent } from './components/northern-lights/northern-lights.component';
import { BackgroundComponent } from './components/background/background.component';
import { TwoFactorInputModule } from './components/two-factor-input/two-factor-input.module';
import { ExpressionEditorComponent } from './components/expression-editor/expression-editor.component';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { ChatWidgetComponent } from './components/chat-widget/chat-widget.component';
import { NawizardUserProfileCardComponent } from './components/chat-widget/components/nawizard-user-profile-card/nawizard-user-profile-card.component';
import { AccessDecisionSummaryComponent } from './components/access-decision-summary/access-decision-summary.component';
import { TrackerSourceIndicatorComponent } from './components/tracker-source-indicator/tracker-source-indicator.component';
import { FeaturePageShellComponent } from './components/feature-page-shell/feature-page-shell.component';
import { SelectablePillGridComponent } from './components/selectable-pill-grid/selectable-pill-grid.component';
import { ToggleSettingCardComponent } from './components/toggle-setting-card/toggle-setting-card.component';
import { FormSectionCardComponent } from './components/form-section-card/form-section-card.component';
import { SegmentedOptionGroupComponent } from './components/segmented-option-group/segmented-option-group.component';
import { WizardSurfaceComponent } from './components/wizard-surface/wizard-surface.component';
import { WizardActionButtonDirective } from './directives/wizard-action-button.directive';
import { CustomReportTableStyleRulesDirective } from './directives/custom-report-table-style-rules.directive';
import { DashboardWidgetCardComponent } from './components/dashboard-widget-card/dashboard-widget-card.component';
import { DashboardWidgetBodyComponent } from './components/dashboard-widget-card/dashboard-widget-body.component';
import { FrostyDialogShellComponent } from './components/frosty-dialog-shell/frosty-dialog-shell.component';
import { ReportWidgetRendererComponent } from './components/report-widget-renderer/report-widget-renderer.component';
import { ReportWidgetDevExtremeChartTemplateComponent } from './components/report-widget-renderer/widget-templates/devextreme-chart/devextreme-chart-template.component';
import { ReportWidgetRanked5ListTemplateComponent } from './components/report-widget-renderer/widget-templates/ranked5list/ranked5list-template.component';
import { ReportWidgetTopOneSpotlightTemplateComponent } from './components/report-widget-renderer/widget-templates/top-one-spotlight/top-one-spotlight-template.component';
import { LocationNodePickerComponent } from './components/location-node-picker/location-node-picker.component';
import { LocationScopePickerComponent } from './components/location-scope-picker/location-scope-picker.component';
import { AuthenticatorAppLinksComponent } from './components/authenticator-app-links/authenticator-app-links.component';

@NgModule({
    declarations: [
        FilterPipe,
        TimeDurationsPipe,
        DatetimeFormatPipe,
        ChatMarkdownPipe,

        GlobalEnumPipe,
        HideTextPipe,

        OrderByPipe,
        VarDirective,


        RangeSwitchCaseDirective,
        TooltipComponent,
        TagItemPropertyTagDetailsComponent,

        SpinnerOverlayComponent,
        SignalRStateComponent,
        NoRecordFoundComponent,

        CrudActionButtonsComponent,
        TagReportFiltersComponent,

        DetailPageHeaderComponent,

        ToggleSwitchComponent,
        AutoFlightSwitchComponent,

        IconResolverComponent,
        ScheduleSlotPresetEditorComponent,
        AccessDecisionSummaryComponent,

        IconSelectorComponent,
        FaIconListComponent,
        FrostyDialogShellComponent,
      
        ListPageBaseComponent,
        DrawDetailContainerComponent,
        ItemPropertyComponent,
        ItemPropertyContainerComponent,
        ProgressItemComponent,
       
        ToggleButtonComponent,
        RecordBaseItemComponent,

        AutocompleteOffDirective,
        VirtualDropDownComponent,

        ImageEditorComponent,
        ImageUploaderComponent,
        DropZoneDirective,
        CoordinateEditorComponent,
        DateRangeComponent,

        NavizardLogoComponent,
        DropdownComponent,
        SecurityAlertComponent,
        HttpDebugToastComponent,
        CopyableErrorToastComponent,
        UpdateModalComponent,
        DebugContainerComponent,
        TagOnlineIndicatorComponent,
        BarcodeEditComponent,
        RelativeTimePipe,
        CalendarTimePipe,
        DatetimeFormatPipe,

        DurationTimePipe,
        MapItemComponent,
        MapDesignerComponent,
        MapDesignerDialogComponent,
        AnimatedTextComponent,
        TextRevealComponent,
        NorthernLightsComponent,
        BackgroundComponent,
        ExpressionEditorComponent,
        ChatWidgetComponent,
        NawizardUserProfileCardComponent,
        TrackerSourceIndicatorComponent,
        FeaturePageShellComponent,
        SelectablePillGridComponent,
        ToggleSettingCardComponent,
        FormSectionCardComponent,
        SegmentedOptionGroupComponent,
        WizardSurfaceComponent,
        DashboardWidgetCardComponent,
        DashboardWidgetBodyComponent,
        ReportWidgetRendererComponent,
        ReportWidgetDevExtremeChartTemplateComponent,
        ReportWidgetRanked5ListTemplateComponent,
        ReportWidgetTopOneSpotlightTemplateComponent,
        WizardActionButtonDirective,
        CustomReportTableStyleRulesDirective,
        LocationNodePickerComponent,
        LocationScopePickerComponent,
        AuthenticatorAppLinksComponent
        
    ],
    imports: [
        CommonModule,

        FormsModule,
        ReactiveFormsModule,
        FontAwesomeModule,
        RouterModule,


        NgxSliderModule,

        UiSwitchModule,

        NgxDaterangepickerMd.forRoot(),

        TranslateModule.forChild(),
        MaterialModule,

        RtlsToolBarModule,
        NgScrollbarModule,

        LetDirective,
        PushPipe,

        PostButtonExecutingModule,

        RtlsCountPieGraphicModule,

        NgxTippyModule,
        ScrollingModule,
        FuseScrollbarDirective,
        BakelorMapModule,
        TruncatePipesModule,
        MatFormFieldModule,
        NgSelectModule,
        ImageCropperModule,
        ZXingScannerModule,
        DxDateBoxModule,
        DxNumberBoxModule,
        DxSelectBoxModule,
        DxSwitchModule,
        DxButtonModule,
        DxChartModule,
        DxPieChartModule,
        TwoFactorInputModule,
        MonacoEditorModule.forRoot({
            baseUrl: 'assets'
        })
  
    ],
    exports: [
        CommonModule,
        RouterModule,

        FormsModule,
        ReactiveFormsModule,
        FontAwesomeModule,
        TranslateModule,



        MaterialModule,


        VarDirective,
    

        RangeSwitchCaseDirective,

        RtlsToolBarModule,

        FilterPipe,
        TimeDurationsPipe,
        DatetimeFormatPipe,

        GlobalEnumPipe,
        HideTextPipe,
        OrderByPipe,

        DetailPageHeaderComponent,
        TooltipComponent,

        AutocompleteOffDirective,

        TagReportFiltersComponent,
        SpinnerOverlayComponent,
        SignalRStateComponent,
        NoRecordFoundComponent,
        CrudActionButtonsComponent,
        IconResolverComponent,
        ScheduleSlotPresetEditorComponent,
        AccessDecisionSummaryComponent,
        TagItemPropertyTagDetailsComponent,

        TruncatePipesModule,
        RtlsCountPieGraphicModule,

        ToggleSwitchComponent,
        AutoFlightSwitchComponent,

        PostButtonExecutingModule,

        IconSelectorComponent,
        FrostyDialogShellComponent,
        LetDirective,
        PushPipe,
        TranslateModule,
        NgScrollbarModule,

        // BaseComponents
        ListPageBaseComponent,
        FuseScrollbarDirective,
        DrawDetailContainerComponent,
        ItemPropertyContainerComponent,
        ItemPropertyComponent,
        ProgressItemComponent,
   
        ToggleButtonComponent,
        RecordBaseItemComponent,
        VirtualDropDownComponent,
        ImageEditorComponent,
        CoordinateEditorComponent,
        NgxDaterangepickerMd,
        DateRangeComponent,
        NavizardLogoComponent,
        UpdateModalComponent,
        DebugContainerComponent,
        TagOnlineIndicatorComponent,
        SecurityAlertComponent,
        HttpDebugToastComponent,
        CopyableErrorToastComponent,
        BarcodeEditComponent,
        RelativeTimePipe, CalendarTimePipe,
        DatetimeFormatPipe,
        DurationTimePipe,
        ChatMarkdownPipe,
        MapItemComponent,
        MapDesignerComponent,
        MapDesignerDialogComponent,
        AnimatedTextComponent,
        TextRevealComponent,
        NorthernLightsComponent,
        BackgroundComponent,
        ExpressionEditorComponent,
        ChatWidgetComponent,
        TwoFactorInputModule,
        TrackerSourceIndicatorComponent,
        FeaturePageShellComponent,
        SelectablePillGridComponent,
        ToggleSettingCardComponent,
        FormSectionCardComponent,
        SegmentedOptionGroupComponent,
        WizardSurfaceComponent,
        DashboardWidgetCardComponent,
        ReportWidgetRendererComponent,
        WizardActionButtonDirective,
        CustomReportTableStyleRulesDirective,
        LocationNodePickerComponent,
        LocationScopePickerComponent,
        AuthenticatorAppLinksComponent

    ],
    providers: [
        TimeDurationsPipe,

        //     { provide: TableIntl, useFactory: languageIntl },
        { provide: MAT_DATE_LOCALE, useValue: 'tr-TR' },

    ],
})
export class SharedModule {

    // constructor(@Optional() @SkipSelf() parentModule: SharedModule) {
    //     if (parentModule) {
    //         throw new Error('SharedModule is already loaded. Please add it in AppModule only.');
    //     }
    // }

    /**
     *
     */
    constructor() {



    }
    static forRoot(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule,
            providers: []
        };
    }

}
